// Global
import { TableColumnsType } from 'antd';

// Models
import { IProductSync } from '@/models/akeneoSync.model';

// Utils
import { renderDate } from 'src/shared/utils/dataRender';
import { ProductSyncErrorSummary } from '../components';

export const productsTableColumns: TableColumnsType<IProductSync> = [
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    width: 180,
    render: (type: string, { productSku }) => <>{productSku ?? type ?? '-'}</>,
  },
  {
    title: 'Channel',
    dataIndex: 'channelSlugs',
    key: 'channelSlugs',
    ellipsis: true,
    render: (channelSlugs: string[]) => <>{channelSlugs?.join(', ') ?? ''}</>,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (status, row) =>
      row.error ? <ProductSyncErrorSummary error={row.error} status={status} /> : <>{status}</>,
  },
  {
    title: 'Date and Time',
    dataIndex: 'timeStart',
    key: 'timeStart',
    render: (timeStart: string) => renderDate(timeStart, 'D MMM, hh:mm a'),
  },
  {
    title: 'Planned Amount',
    dataIndex: 'totalPlanned',
    key: 'totalPlanned',
    width: 180,
    render: (_, record) => <>{record?.status === 'estimating' ? '...' : record?.totalPlanned}</>,
  },
  {
    title: 'Already Updated',
    dataIndex: 'totalSucceeded',
    key: 'totalSucceeded',
    width: 160,
    render: (totalSucceeded: number) => <>{totalSucceeded}</>,
  },
  {
    title: 'Failed Amount',
    dataIndex: 'totalFailed',
    key: 'totalFailed',
    width: 160,
    render: (totalFailed: number) => <>{totalFailed}</>,
  },
];
